import React from 'react';
import './App.css';
import NavBar from './container/NavBar/NavBar';
import Header from './container/Header/Header';
import IntroText from './container/IntroText/IntroText'
import ProjectText from './container/Project/ProjectText';
import ProjectImage from './container/Project/ProjectImage';
import Footer from './container/Footer/Footer';
import ContactMe from './container/Contact/Contact';
import UpArrow from './container/UpArrow/UpArrow';



const App = () => (
  <div>
      <NavBar/>

      <div className='grid'>
        <Header />
        <IntroText />
        <ProjectText />
        <ProjectImage />
        <ContactMe />
        <UpArrow />
        <Footer />
      </div>


  </div>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js